import GoogleMap from './GoogleMap.vue';
import Autocomplete from './Autocomplete.vue';

export {
    GoogleMap,
    Autocomplete
}